import {Image} from '@codeurs/front'
import React, {useState} from 'react'
import {style} from 'util/style'
import {Theme} from '../Theme'
import {CountryType} from './worldmap/RegionSelector'
import {ThemePageType} from './worldmap/Themes'
import {ContinentType} from './worldmap/Worldmap'

import './SidebarCountry.scss'
import {useTranslation} from '../../util/i18n'
import {getIcon} from './worldmap/ThemeIcon'

const styles = style('sidebarcountry', ['head', 'themes', 'theme'])

type SidebarCountryType = {
	country: CountryType
	continent: string
	themes: Array<ThemePageType>
}

export const SidebarCountry: React.FC<SidebarCountryType> = ({
	continent,
	country,
	themes
}) => {
	return (
		<div className={styles}>
			<div className={styles('head')}>
				<SidebarCountryRegion country={country} continent={continent} />
			</div>
			<div className={styles('card')}>
				<SidebarCountryThemes themes={themes} />
			</div>
		</div>
	)
}

export const SidebarCountryRegion: React.FC<{
	country: CountryType
	continent: string
}> = ({continent, country}) => {
	const [isLoaded, setLoaded] = useState(false)
	const {globe = null, title = null, url} = country
	return (
		<div className={styles.head}>
			{globe && (
				<Theme.Link
					to={url}
					className={styles.head('globe').is({loaded: isLoaded})}
				>
					<Image src={globe?.src} onLoad={setLoaded} />
				</Theme.Link>
			)}
			<div className={styles.head('info')}>
				{title && url && (
					<div className={styles.head('info-country')}>
						<Theme.Link to={url}>
							<Theme.H4 as="h3" mod="green">
								{country.title}
							</Theme.H4>
						</Theme.Link>
					</div>
				)}
				{continent && (
					<div className={styles.head('info-continent')}>
						<Theme.H5 as="h4">{continent}</Theme.H5>
					</div>
				)}
			</div>
		</div>
	)
}

export const SidebarCountryThemes: React.FC<{
	themes: Array<ThemePageType>
}> = ({themes}) => {
	const t = useTranslation('impact').projects.country_fiche
	const hasThemes = themes?.length > 0
	if (!hasThemes) return null
	return (
		<div className={styles.themes}>
			<p className={styles.themes('title')}>{t.focus_themes}</p>
			<ul className={styles.themes('overview')}>
				{themes.map((theme) => (
					<SidebarCountryTheme key={theme.url} theme={theme} />
				))}
			</ul>
		</div>
	)
}

export const SidebarCountryTheme: React.FC<{
	theme: ThemePageType
}> = ({theme}) => {
	const {title = null, url = null, icon} = theme
	if (!url || !title) return null
	return (
		<li className={styles.theme}>
			<Theme.Link to={url} className={styles.theme('icon')}>
				{getIcon(icon)}
			</Theme.Link>
			<Theme.Link className={styles.theme('link')} to={url}>
				{title}
			</Theme.Link>
		</li>
	)
}
